import React from "react";
import { connect } from "@irati/store";
import { FormattedMessage } from "@irati/utils/lang";
import CurrentPositionMarker from "@irati-web/geolocation/src/components/GeoMap/CurrentPositionMarker";
import Flex from "@irati/ui/src/Flex";
import { Body } from "@irati/ui/src/Typography";
import { OverlayPlacement } from "@irati/ui/src/Tooltip/Overlay";
import { StyledTooltip, StyledOverlay, StyledBr } from "./styled/LocationAccuracyInfo";
var LocationAccuracyInfo = function (_a) {
    var isMobile = _a.isMobile;
    return (React.createElement(Flex, { alignItems: "center" },
        React.createElement(CurrentPositionMarker, null),
        React.createElement(Body, { small: true, margin: [0, 1, 0] },
            React.createElement(FormattedMessage, { id: "perks.searchByLocation.locationAccuracyInfo.header" })),
        React.createElement(StyledTooltip, { placement: isMobile ? OverlayPlacement.Bottom : OverlayPlacement.Top, OverlayComponent: StyledOverlay },
            React.createElement(Body, { small: true },
                React.createElement(FormattedMessage, { id: "perks.searchByLocation.locationAccuracyInfo.tooltip.text", values: {
                        boldHeader: (React.createElement(Body, { small: true, weight: "bold", color: "ink", marginBottom: 1 },
                            React.createElement(FormattedMessage, { id: "perks.searchByLocation.locationAccuracyInfo.tooltip.boldHeader" }))),
                        br: React.createElement(StyledBr, null)
                    } })))));
};
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({ isMobile: mq.lessThan.md });
};
export default React.memo(connect(mapStateToProps, null)(LocationAccuracyInfo));
